import { createSelector } from 'reselect';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { type StoreState } from '../types/StoreState';
import { type GooglePayPaymentMethod } from '../types/PaymentMethods';
import { selectTopProps } from './topProps';

export const selectGooglePayDto = (store: StoreState): GooglePayPaymentMethod | undefined => {
  return store.domain.paymentMethods.find((pm) => !!pm[PaymentMethod.GooglePay]) as GooglePayPaymentMethod;
};

export const selectGooglePayBtnColor = createSelector(selectTopProps, (topProps) => {
  return topProps.theme === 'light' ? ('white' as const) : ('black' as const);
});

export const selectGooglePayCountryCode = createSelector(
  selectGooglePayDto,
  (pm: GooglePayPaymentMethod): string => pm && pm[PaymentMethod.GooglePay].merchantCountry,
);

export const selectGooglePaySupportedNetworks = createSelector(
  selectGooglePayDto,
  (pm: GooglePayPaymentMethod) => pm && pm[PaymentMethod.GooglePay].allowCardNetworks,
);

export const selectGooglePayOptions = (store: StoreState) => {
  return store.googlePay.options;
};

export const selectGooglePayButton = (store: StoreState) => {
  return store.googlePay.button;
};

export const selectGooglePayPaymentData = (store: StoreState) => {
  return store.googlePay.paymentData;
};

export const selectGooglePayButtonAvailable = createSelector(
  selectGooglePayDto,
  selectTopProps,
  selectGooglePayOptions,
  (pm, topProps, options) => {
    if (!topProps.allowPaymentMethods.includes(PaymentMethod.GooglePay)) {
      return false;
    }
    if (pm && topProps.demoMode) {
      return true;
    }

    if (Number(topProps.paymentAmount) < 1) {
      // WixPayments min transaction is amount 1$
      return false;
    }

    if (!pm) {
      return false;
    }

    if (options.loading === 'rejected') {
      return false;
    }

    return true;
  },
);

export const selectGooglePayButtonReady = createSelector(
  selectGooglePayButtonAvailable,
  selectGooglePayButton,
  (isAvailable, button) => {
    return isAvailable && button.visibility === 'visible';
  },
);
